/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React, {useState} from 'react';
import {CHECK_EMAIL, CHECK_PASSWORD} from "../../data/formats";
import {postTo} from "../../data/api";
import RegisterView from "../../views/auth/RegisterView";
import {Navigate, useHistory, useLocation} from "react-router-dom";
import {useAuth} from "../../data/userContext";
import {isAuthenticated} from "../../data/roles";

function RegisterRoute(props) {
    const [user, setUser] = useState({email: "", password: "", passwordAgain: "", name: ""})
    const [submitting, setSubmitting] = useState(false)
    const [info, setInfo] = useState({text: "", severity: ""})


    const auth = useAuth();
    const location = useLocation()
    const from = location.state?.from?.pathname || "/";
    const changeData = (which, e) => {
        switch (which){
            case "email": setUser({...user, email: e.target.value}); break;
            case "password": setUser({...user, password: e.target.value}); break;
            case "passwordAgain": setUser({...user, passwordAgain: e.target.value}); break;
            case "name": setUser({...user, name: e.target.value}); break;
            default: break;
        }
    }
    const submitRegisterForm = (e) => {
        e.preventDefault();
        setSubmitting(true)
        if(!CHECK_EMAIL.test(user.email)) {
            //Failed email format
            setSubmitting(false)
            return
        }
        if(user.password !== user.passwordAgain || !CHECK_PASSWORD.test(user.password)){
            //Failed passwords format || match
            setSubmitting(false)
            return
        }
        postTo('/register', user)
            .then((res) => {
                setSubmitting(false)
                //Successful register
                setUser({email: "", password: "", passwordAgain: "", name: ""})
                setInfo({text: "Uživateľ registrovaný - O chvíľu vás to prihlási!", severity: "success"})
                window.location.reload();

            })
            .catch((e) => {
                setSubmitting(false)
                //Bad register
                if(e.response.status === 500)
                    setInfo({text: "Užívateľ už existuje", severity: "error"})
                else
                    setInfo({text: "Internal server error", severity: "error"})
            })

    }

    if (isAuthenticated(auth.user)){
        return <Navigate replace to={from}/>
    }else{
        return <RegisterView submit={submitRegisterForm}
                          isSubmitting={submitting}
                          onPasswordChange={(e)=>{changeData('password', e)}}
                          onPasswordAgainChange={(e)=>{changeData('passwordAgain', e)}}
                          onEmailChange={(e)=>{changeData('email', e)}}
                          onnNameChange={(e)=>{changeData('name', e)}}
                          user={user}
                          info={info}
        />;
    }
}


export default RegisterRoute;